import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import marketingNoiBoService from "services/hrm/marketingNoiBoService";

export const getAllMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingNoiBoService.getAll(params);
      return res.data?.data ?? res.data ?? [];
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/upsert",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = { ...data };
      delete payload.onSuccess;
      const res = await marketingNoiBoService.upsert(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/delete",
  async ({ id, onSuccess }, { rejectWithValue }) => {
    try {
      const res = await marketingNoiBoService.delete(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getActiveMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/getActive",
  async (_, { rejectWithValue }) => {
    try {
      const res = await marketingNoiBoService.getActiveForUser();
      return res.data?.data ?? res.data ?? [];
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ghiLogMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/ghiLog",
  async (data, { rejectWithValue }) => {
    try {
      await marketingNoiBoService.ghiLog(data);
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const guiThongBaoMarketingNoiBo = createAsyncThunk(
  "marketingNoiBo/guiThongBao",
  async ({ id, onSuccess }, { rejectWithValue }) => {
    try {
      const res = await marketingNoiBoService.guiThongBao(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const pending = (state) => { state.loading = true; };
const rejected = (state) => { state.loading = false; };

const marketingNoiBoSlice = createSlice({
  name: "marketingNoiBo",
  initialState: {
    loading: false,
    list: [],
    activeList: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllMarketingNoiBo.pending, pending)
      .addCase(getAllMarketingNoiBo.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(getAllMarketingNoiBo.rejected, rejected)

      .addCase(upsertMarketingNoiBo.pending, pending)
      .addCase(upsertMarketingNoiBo.fulfilled, (state) => { state.loading = false; })
      .addCase(upsertMarketingNoiBo.rejected, rejected)

      .addCase(deleteMarketingNoiBo.pending, pending)
      .addCase(deleteMarketingNoiBo.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteMarketingNoiBo.rejected, rejected)

      .addCase(guiThongBaoMarketingNoiBo.pending, pending)
      .addCase(guiThongBaoMarketingNoiBo.fulfilled, (state) => { state.loading = false; })
      .addCase(guiThongBaoMarketingNoiBo.rejected, rejected)

      .addCase(getActiveMarketingNoiBo.pending, (state) => { state.loading = false; })
      .addCase(getActiveMarketingNoiBo.fulfilled, (state, action) => {
        state.activeList = action.payload;
      })
      .addCase(getActiveMarketingNoiBo.rejected, (state) => { state.loading = false; })

      .addCase(ghiLogMarketingNoiBo.pending, () => {})
      .addCase(ghiLogMarketingNoiBo.fulfilled, () => {})
      .addCase(ghiLogMarketingNoiBo.rejected, () => {});
  },
});

export default marketingNoiBoSlice.reducer;
